<script>
import Layout from "@layouts/form";
import ExpedienteLocal from "@forms/ExpedienteLocal";

export default {
  page: {
    title: "Detalhes | Local do expediente"
  },
  components: { Layout, ExpedienteLocal },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Local do expediente",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Local do expediente",
          href: "/ExpedienteLocal"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <ExpedienteLocal :editable="editable"></ExpedienteLocal>
    </div>
  </Layout>
</template>
